module.exports = emojione;